<template>
  <div class="contact-toolbar-dark-component">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 vcenter hidden-md toolbar-address">
          <div class="address">
            <a alt="Address" aria-label="address" class="track-click" data-action="Address Click" data-category="Hours &amp;amp; Directions" data-label="Dealership Address Link" href="#"><i aria-hidden="true" class="fa fa-map-marker"></i>100 Your Address, City, ST 12345</a>
          </div>
        </div>
        <div class="col-lg-6 vcenter toolbar-phone-numbers">
          <div class="text-center">
            <a aria-label="sales number" class="sales phone-link ws-dynamic-number" data-number-type="sales" href="#">
              <i aria-hidden="true" class="fa fa-phone"></i>
              <span class="phone-label">Sales:&nbsp;</span>
              <span class="phone-number">(555) 555-5555</span>
            </a>
            <a aria-label="service number" class="sales phone-link ws-dynamic-number" data-number-type="service" href="#">
              <i aria-hidden="true" class="fa fa-phone"></i>
              <span class="phone-label">Service:&nbsp;</span>
              <span class="phone-number">(555) 555-5555</span>
            </a>
            <a aria-label="parts number" class="sales phone-link ws-dynamic-number" data-number-type="parts" href="#">
              <i aria-hidden="true" class="fa fa-phone"></i>
              <span class="phone-label">Parts:&nbsp;</span>
              <span class="phone-number">(555) 555-5555</span>
            </a>
          </div>
        </div>
        <div class="col-lg-3 vcenter toolbar-social">
          <a aria-label="Facebook" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="Facebook" href="#" target="_blank">
            <i aria-hidden="true" class="fa fa-facebook"></i>
          </a>
          <a aria-label="Instagram" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="Instagram" href="#" rel="" target="_blank">
            <i aria-hidden="true" class="fa fa-instagram"></i>
          </a>
          <a aria-label="YouTube" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="YouTube" href="#" target="_blank">
            <i aria-hidden="true" class="fa fa-youtube"></i>
          </a>
          <div class="pull-right" aria-hidden="true" tabindex="-1">
            <div id="google_translate_element">
              <div class="skiptranslate goog-te-gadget" dir="ltr">
                <div id=":0.targetLanguage" class="goog-te-gadget-simple" style="white-space: nowrap;">
                  <img src="https://www.google.com/images/cleardot.gif" class="goog-te-gadget-icon" alt="cleardot" style="background-image: url(https://translate.googleapis.com/translate_static/img/te_ctrl3.gif); background-position: -65px 0px; height: 18px; margin-right: 3px;">
                  <span style="vertical-align: middle;">
                    <a aria-haspopup="true" class="goog-te-menu-value" href="javascript:void(0)" aria-hidden="true" tabindex="-1">
                      <span>Select Language</span>
                      <img src="https://www.google.com/images/cleardot.gif" alt="" width="1" height="1" role="presentation">
                      <span style="border-left: 1px solid rgb(187, 187, 187);">​</span>
                      <img src="https://www.google.com/images/cleardot.gif" alt="" width="1" height="1" role="presentation">
                      <span aria-hidden="true" style="color: rgb(118, 118, 118);">▼</span>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="toolbar_shadow"></div>
  </div>
</template>

<script async="true" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>

<script>
export default {
  data() {
    return {
      sideNavOpen: false
    }
  },
  mounted() {
    var domains = location.host.split('.')
    var lang = domains[0] === 'es' ? 'es' : 'en';

      function googleTranslateElementInit() {
        new google.translate.TranslateElement({
          pageLanguage: 'en',
          includedLanguages: 'ar,bg,da,de,el,en,es,fr,ga,hmn,hu,id,it,iw,ja,jv,ko,la,nl,pl,pt,ru,sv,sw,th,tl,tr,uk,vi,zh-CN',
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE
        }, 'google_translate_element');
      }
    },
  methods: {
    addOpen: function (e) {
      e.target.classList.add("open");
    },
    removeOpen: function (e) {
      e.target.classList.remove("open");
    },
    toggleSideNav: function () {
      this.sideNavOpen = !this.sideNavOpen;
    },
    closeSideNav: function () {
      this.sideNavOpen = false;
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .contact-toolbar-dark-component {
    padding: 5px;
    color: #fff;
    min-height: 30px;
    position: relative;
    z-index: 5555;
    background: rgba(0, 0, 0, 0.9);
    display: block;
    font-family: Helvetica, Arial, sans-serif;
  }
  .contact-toolbar-dark-component > .container {
    padding-top: 0;
    padding-bottom: 0;
  }
  .contact-toolbar-dark-component a {
    color: #929596;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .contact-toolbar-dark-component a:hover, .contact-toolbar-dark-component a:hover i.fa {
    color: #FFF;
    color: #929596;
    text-decoration: none;
  }
  .contact-toolbar-dark-component .phone-link {
    margin-left: 10px;
  }
  .contact-toolbar-dark-component #google_translate_element .goog-te-gadget-simple {
    font-size: 12px;
  }
  .contact-toolbar-dark-component #google_translate_element img {
    opacity: .7;
  }
  .contact-toolbar-dark-component #google_translate_element .goog-te-gadget-simple {
    background-color: transparent;
    border: none;
    padding: 0;
  }
  .contact-toolbar-dark-component #google_translate_element .goog-te-gadget-simple a.goog-te-menu-value span {
    color: #929596;
    color: #fff;
    font-size: 12px;
  }
  .contact-toolbar-dark-component #google_translate_element:hover .goog-te-gadget-simple a.goog-te-menu-value span {
    color: #fff;
    color: #929596;
  }
  .contact-toolbar-dark-component .fa {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-right: 5px;
    font-size: 16px;
  }

  @media (max-width: 1199px) {
    .contact-toolbar-dark-component .toolbar-phone-numbers, .contact-toolbar-dark-component .toolbar-address {
      display: none;
    }
    .contact-toolbar-dark-component .toolbar-social {
      display: block;
    }
  }

  @media (min-width: 1200px) {
    .contact-toolbar-dark-component > .container {
      padding: 0;
    }
  }
</style>
